import type { Product } from '~/api/products/types';

import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  categories: Product['productCategories'];
};

export const ProductCategoriesCell = ({ categories }: Props) => <span className={desktopTruncateStyle}>{categories.join(', ')}</span>;
